import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CallToAction = ({ onGetStarted }) => {
  return (
    <section className="pb-20 px-4">
      <div className="max-w-6xl mx-auto rounded-[2rem] bg-collaborb-inner text-white p-8 md:p-12 shadow-2xl overflow-hidden relative">
        <div className="absolute inset-y-0 right-0 w-1/2 bg-[radial-gradient(circle_at_top_right,rgba(127,182,255,0.22),transparent_40%)]" />
        <div className="relative z-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <div className="section-kicker mb-4 !bg-white/10 !text-sky-200">Ready to launch</div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Make CollabOrb feel like a premium product from the first click.
            </h2>
            <p className="text-lg text-slate-300">
              Improve trust on public pages, remove friction in onboarding, and give brands and creators clearer product journeys.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <button onClick={onGetStarted} className="primary-button">
              Start now
              <ArrowRight className="h-4 w-4" />
            </button>
            <Link to="/contact" className="secondary-button !bg-white/5 !text-white !border-white/10">
              Talk to the team
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
